
var autoCompleteCategories =  [
    {'name': 'product',   'description' : 'Producten',   'defaultLength' : 4},
    {'name': 'author',    'description' : 'Auteurs',     'defaultLength' : 2},
    {'name': 'category', 'description' : 'Categorieën', 'defaultLength' : 2},
    {'name': 'publisher', 'description' : 'Uitgeverijen', 'defaultLength' : 2}
];
